import React, { useState } from 'react';
import styles from './RoleSettingSection.module.scss';
import { Grid, Button } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CustomButton from '../../layout/customButton/CustomButton';
import RoleSettingTable from './roleSettingTable/RoleSettingTable';
import { openModal } from '../../../redux/modals/action';
import AddRoleModal from './addRoleModal/AddRoleModal';
import { connect } from 'react-redux';
import ConfirmationComponent from '../../confirmation/ConfirmationComponent';
import {
	setConfirmation,
	closeConfirmation,
} from '../../../redux/confirmations/actions';
import { deleteRole } from '../../../api/UserManagement/deleteRole.api';
import { setAlert } from '../../../redux/alerts/action';

const RoleSettingSection = (props) => {
	const {
		setSection,
		modals,
		openModal,
		setConfirmation,
		closeConfirmation,
		confirmation,
		projectSelectedCode,
		setAlert,
	} = props;
	const [roleSelected, setRoleSelected] = useState();
	const [deleteRoleId, setDeleteRoleId] = useState();

	const handleAddRole = () => {
		openModal('addRole');
	};

	const handleOpenDeleteRolesConfirmation = async (id) => {
		await setConfirmation('deleteRoles');
		setDeleteRoleId(id);
	};

	const handleCloseDeleteRolesConfirmation = () => {
		closeConfirmation('deleteRoles');
	};

	const handleDeleteRolesConfirmation = async () => {
		if (projectSelectedCode && deleteRoleId) {
			await deleteRole(projectSelectedCode, deleteRoleId);
			setAlert('success', 'Delete role successfully.');
		} else {
			setAlert('error', 'Failed to delete role.');
		}
		closeConfirmation('deleteRoles');
	};

	const deleteRolesButtonList = [
		{
			name: 'Discard',
			action: () => {
				handleCloseDeleteRolesConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Yes',
			action: () => {
				handleDeleteRolesConfirmation();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--error)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	return (
		<div className={styles.role_setting_section}>
			<Grid container spacing={1}>
				<Grid item xs={8}>
					<div className={styles.btn_group}>
						<Button
							className={styles.back_btn}
							startIcon={
								<ArrowBackIosIcon
									className={styles.back_btn_icon}
								/>
							}
							size='small'
							onClick={() => setSection('user list')}
						>
							Back to User Management
						</Button>
						<CustomButton
							width={166}
							height={42}
							onClick={handleAddRole}
						>
							Add
						</CustomButton>
					</div>
				</Grid>
				<Grid item xs={8}>
					<RoleSettingTable
						setRoleSelected={setRoleSelected}
						openDeleteRolesConfirmation={
							handleOpenDeleteRolesConfirmation
						}
					/>
				</Grid>
			</Grid>
			<AddRoleModal
				showModal={modals.addRole}
				roleSelected={roleSelected}
				setRoleSelected={setRoleSelected}
			/>
			<ConfirmationComponent
				open={confirmation?.deleteRoles}
				handleClose={handleCloseDeleteRolesConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={deleteRolesButtonList}
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	modals: state.modals,
	confirmation: state.confirmation,
	projectSelectedCode: state.userManagement.projectSelectedCode,
});
export default connect(mapStateToProps, {
	openModal,
	setConfirmation,
	closeConfirmation,
	setAlert,
})(RoleSettingSection);
